module.exports = __webpack_public_path__ + "img/66-green.f595eb34.svg";